import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
// import Navigation from 'presentation/components/navigationMenu'
import Navigation from 'presentation/components/navigationV2'

const RouteWrapper = ({ component, isProtected, hideMenu, ...rest }) => {
  const isSigned = useSelector((state) => state.auth.signed)

  if (isProtected && !isSigned) return <Redirect to='/login' />

  if (!isProtected && isSigned) return <Redirect to='/' />

  return (
    <Navigation hideMenu={hideMenu}>
      <Route component={component} {...rest} />
    </Navigation>
  )
}

export default RouteWrapper
